// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1yERo","name":"styles_name__9d8GF","phone":"styles_phone__39PLL"};